<template>
  <div class="cat-select">
    <div class="cat-label" v-if="label">{{ label }}</div>
    <div class="cat-grid">
      <button
        v-for="cat in categories"
        :key="cat.id"
        type="button"
        class="cat-tile"
        :class="{ 'is-selected': isSelected(cat) }"
        :disabled="disabled"
        @click="pick(cat)"
        :data-intercom-target="'select.category.' + cat.id"
      >
        <v-icon class="cat-icon">{{ cat.icon }}</v-icon>
        <span class="cat-name">{{ cat.display_name }}</span>
        <span class="cat-check" v-if="isSelected(cat)">
          <v-icon x-small>fal fa-check</v-icon>
        </span>
      </button>
    </div>
    <div class="cat-error" v-if="errorMessages && errorMessages.length">
      {{ Array.isArray(errorMessages) ? errorMessages[0] : errorMessages }}
    </div>
  </div>
</template>

<script>
import { mapActions } from "vuex";

export default {
  props: {
    value: { required: true },
    disabled: { type: Boolean, default: false },
    "error-messages": { type: [Array, String], default: () => [] },
    returnObject: { default: true, type: Boolean },
    multiple: { default: true, type: Boolean },
    hasIcons: { default: false, type: Boolean },
    label: { default: "Categories", type: String }
  },
  data: () => ({ categories: [] }),
  methods: {
    ...mapActions("core", ["getChannelCategories"]),
    isSelected(cat) {
      if (this.returnObject) {
        if (this.multiple) return Array.isArray(this.value) && this.value.some(v => Number(v.id) === Number(cat.id));
        return this.value && Number(this.value.id) === Number(cat.id);
      } else {
        if (this.multiple) return Array.isArray(this.value) && this.value.map(Number).includes(Number(cat.id));
        return Number(this.value) === Number(cat.id);
      }
    },
    pick(cat) {
      if (this.disabled) return;
      if (this.multiple) {
        // toggle in array
        let current = Array.isArray(this.value) ? [...this.value] : [];
        const key = this.returnObject ? cat : cat.id;
        const idx = current.findIndex(v => Number(this.returnObject ? v.id : v) === Number(cat.id));
        if (idx === -1) current.push(key);
        else current.splice(idx, 1);
        this.$emit("input", current);
      } else {
        // single select
        const key = this.returnObject ? cat : cat.id;
        this.$emit("input", key);
      }
    }
  },
  computed: {
    icon() {
      const item = this.categories.find(item => Number(item.id) === Number(this.value && this.value.id));
      return item ? item.icon : null;
    }
  },
  created() {
    this.getChannelCategories().then(response => {
      this.categories = response.data.channelCategories;
    });
  }
};
</script>

<style scoped>
.cat-select { width: 100%; }

.cat-label {
  font-size: 12px;
  font-weight: 600;
  text-transform: uppercase;
  letter-spacing: .06em;
  color: var(--ink-2, #6b7280);
  margin-bottom: 12px;
}

.cat-grid {
  display: grid;
  grid-template-columns: repeat(auto-fill, minmax(110px, 1fr));
  gap: 10px;
}

.cat-tile {
  position: relative;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  gap: 8px;
  padding: 16px 10px 14px;
  background: var(--surface, #fff);
  border: 1.5px solid var(--line, #e5e7eb);
  border-radius: var(--r-card, 10px);
  cursor: pointer;
  transition: border-color .15s, box-shadow .15s, background .15s;
  text-align: center;
  outline: none;
  -webkit-font-smoothing: antialiased;
}

.cat-tile:hover:not(:disabled) {
  border-color: var(--accent, #6366f1);
  box-shadow: 0 0 0 3px rgba(99,102,241,.12);
}

.cat-tile.is-selected {
  border-color: var(--accent, #6366f1);
  background: rgba(99, 102, 241, .07);
  box-shadow: 0 0 0 3px rgba(99,102,241,.15);
}

.cat-tile:disabled {
  opacity: .45;
  cursor: not-allowed;
}

.cat-icon {
  font-size: 22px !important;
  color: var(--ink-2, #6b7280);
  transition: color .15s;
}
.cat-tile.is-selected .cat-icon {
  color: var(--accent, #6366f1);
}

.cat-name {
  font-size: 12px;
  font-weight: 500;
  color: var(--ink-1, #374151);
  line-height: 1.3;
}
.cat-tile.is-selected .cat-name {
  color: var(--accent, #6366f1);
  font-weight: 600;
}

.cat-check {
  position: absolute;
  top: 6px;
  right: 7px;
  width: 16px;
  height: 16px;
  border-radius: 50%;
  background: var(--accent, #6366f1);
  display: flex;
  align-items: center;
  justify-content: center;
  color: #fff;
  font-size: 9px;
}
.cat-check .v-icon {
  font-size: 9px !important;
  color: #fff !important;
}

.cat-error {
  margin-top: 8px;
  font-size: 12px;
  color: #ef4444;
}
</style>